/**
 * TEMPORARY MOVE FROM JS.COOKIES.JS TO MAIN.JS
 * FOR TESTING
 * TODO: GO BACK TO ORIGINAL FILE AND REMOVE DUPLICATE.
 */

/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
; (function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === 'function' && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === 'object') {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = window.Cookies = factory();
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
}(function () {  
  function extend() {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[i];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init(converter) {
    function api(key, value, attributes) {
      var result;
      if (typeof document === 'undefined') {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
          attributes.expires = expires;
        }

        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) { }

        if (!converter.write) {
          value = encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += '; ' + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += '=' + attributes[attributeName];
        }
        return (document.cookie = key + '=' + value + stringifiedAttributes);
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var cookie = parts.slice(1).join('=');

        if (!this.json && cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read ?
            converter.read(cookie, name) : converter(cookie, name) ||
            cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) { }
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) { }
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply({
        json: true
      }, [].slice.call(arguments));
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(key, '', extend(attributes, {
        expires: -1
      }));
    };

    api.withConverter = init;

    return api;
  }

  return init(function () { });
}));


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($, Cookies) {
  var slicks = [];
  var checkLoadingReactApps;
  // Mobilidade Eletrica Map Variables
  var mapMarkers = []; // Array of markers to add to Map
  var filterMapNames = []; // Array of the fields selected to filter the map
  var mapsPlaceholder = null; // Variable to hold the instance of map
  var controlSearch = null; // Variable to hold the instance of controlSearch



  // ChargingStations
  var chargingStationsMap;
  var chargingStationsMarkers = [];


  /**
   * Sets slick slider for mobile boxes
   */
  function setSlickMobile() {
    if ($(window).width() <= 790) {

      var $boxes = $('.vc_row > .box');
      var $widgets = $('.tips-component.widget');

      if ($boxes.length) {
        var slick = $boxes.parent().slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px',
          arrows: false,
          dots: true,
        });
        slicks.push(slick);

        var slick2 = $widgets.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px',
          arrows: false,
          dots: true,
        });
        slicks.push(slick2);
      }

    } else {
      slicks.forEach(function (s) {
        if (s.hasClass('slick-initialized')) {
          s.slick('unslick');
        }
      });
      slicks = [];
    }
  }

  function setScrolledHeader() {
    var mobileMenuAtScrolledNavbar = false;
    var $mobileTopNavbar = $('.main-header .mobile-menu');

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 95) {
        $('body').addClass('scrolled');

        // move mobile-menu to scrolled nav
        if (!mobileMenuAtScrolledNavbar) {
          if ($mobileTopNavbar.length === 0) {
            mobileMenuAtScrolledNavbar = true;
            $('.mobile-menu')
              .detach()
              .prependTo('.banner.main-header .container');
          }
        }

      } else {
        $('body').removeClass('scrolled');

        // move mobile-menu to menu-primario-container
        if (mobileMenuAtScrolledNavbar) {
          $('.mobile-menu')
            .detach()
            .appendTo('.nav-primary .menu-primario-container');
          mobileMenuAtScrolledNavbar = false;
        }
      }
    });
  }

  //moves horizontal line (menus)
  function moveUnderline(el, menu) {
    if (el === null) { return; }
    var $underline = menu.find('hr');
    var left = el.offset().left;
    var width = el.width();
    $underline.css({
      'left': left,
      'width': width
    });
  }

  //created horizontal line below navPrimary and moves it when hovering menu items.
  function navUnderline() {

    var $menu = $('.nav-primary');
    var $active = $menu.find('.menu-item.current-menu-item').first();
    var $menuItem = $menu.find('.menu-item');
    var underlineStopped = false;
    //add underline element to menus if none exist
    if ($menu.find('hr').length === 0) {
      $menu.append('<hr class="underline" />');
    }

    //If no menu is active, underline the first one
    if ($active.length === 0) {
      $active = null;
    }

    //when page loads, moves line to active menu
    moveUnderline($active, $menu);

    // Flag for underline to stop moving after click
    $menuItem.click(function () {
      underlineStopped = true;
    });

    //moves the line below hovered menu item
    $menuItem.mouseenter(function () {
      if (!underlineStopped) {
        moveUnderline($(this), $menu);
      }
    });

    //if mouse leaves the menu, moves underline back to the active item.
    $menu.mouseleave(function () {
      if (!underlineStopped) {
        moveUnderline($active, $menu);
      }
    });
  }


  function bannerlogosAnimation() {
    var $banners = $('.banner-slider');
    if ($banners.length) {
      $banners.each(function () {
        $banners.slick({
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: 'linear',
          variableWidth: true,
          infinite: true,
          initialSlide: 10,
          arrows: false,
          buttons: false
        });
      });
    }
  }



  // Possibly hacky solution to wrap boxes with anchor making the whole box clickable
  function wrapBoxWithAnchor() {
    var $boxPops = $('.box:has(.adene-see-more)');
    if ($boxPops.length) {
      // For each .box, find adene-see-more and wrap box with link
      $boxPops.each(function () {
        var $anchors = $(this).find('.adene-see-more');
        if ($anchors.length > 0) {
          var $href = $anchors.attr('href');
          var $newAnchor = '<a class="wrappedAnchor" href=' + $href + '></a>';
          $(this).find('.wpb_wrapper').first().wrap($newAnchor);
        }
      });
    }
  }

  function headerSlider() {
    var $imageSlider = $('.header-slider');
    if ($imageSlider.length) {
      $imageSlider.each(function () {
        $(this).slick({
          speed: 800,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 7000,
          arrows: false,
          dots: true,
          fade: true,
          pauseOnHover: false
        });
      });
    }
  }

  // Mobile Menu
  // append an element with hamburger menu to the navbar
  // add / remove classes to show / hide mobile navigation
  function showMenuOnMobile() {
    var $nav = $('.nav-primary .nav');
    var $underline = $('.nav-primary .underline');

    // Append hamburguer if there's none
    if ($('.mobile-menu').length === 0) {
      $nav.parent().append('<div class="mobile-menu"><img class="openIcon" src="/app/themes/custom/assets/images/ic-menu.svg"/><img class="closeIcon" src="/app/themes/custom/assets/images/ic-menu-close.svg"/><h1>Menu</h1></div>');
    }

    $('.mobile-menu').click(function () {
      if ($nav.hasClass('showMenu')) {
        $nav.removeClass('showMenu');
        $nav.addClass('hideMenu');

        //remove class to avoid the animation from replaying when resizing window
        $nav.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
          $nav.removeClass('hideMenu');
        });

      } else {
        $nav.addClass('showMenu');
        $nav.removeClass('hideMenu');
      }
    });

  }

  function showNavSearchInput() {
    var $searchWidgetContainer = $('.nav-primary .right-container .widget_search');
    var $searchForm = $('.nav-primary .right-container .search-form');
    var $searchInput = $('.nav-primary .right-container .search-field');


    $searchWidgetContainer.click(function () {
      if (!$searchWidgetContainer.hasClass('showSearch')) {
        $searchForm.addClass('showSearch');
        $searchInput.focus();
      }
    });

    $searchInput.blur(function () {
      $searchForm.removeClass('showSearch');
    });
  }

  function gradientRowHover() {
    $el = $('.adene-infobox-wrap');
    if ($el.length > 0) {
      $el.hover(
        function () {
          $(this).addClass('infobox-hover');
        }, function () {
          $(this).removeClass('infobox-hover');
        });
    }
  }

  function cycleFeaturedArticles() {
    var $featured = $('.articles .featured');
    var $feature = $('.articles .featured .feature');
    var nFeature = $feature.length;
    var delay = 3000;

    //====== FUNCTIONS ========
    // reveal an item
    function show($item) {
      $item.removeClass('invisible');
    }

    // hide an item
    function hide($item) {
      $item.addClass('invisible');
    }

    // cycle function.
    function cycle() {
      //get the only visible element and set it to current
      var $current = $feature.not('.invisible');
      // get the next element in line. If the index is greater
      // than the array length, set it to 0
      var nextIndex = $feature.index($current) + 1;
      if (nextIndex >= $feature.length) {
        nextIndex = 0;
      }
      var $next = $($feature.get(nextIndex));

      //hide current item
      hide($current);
      //show the next one
      show($next);

      // loop cycle every 3 seconds
      setTimeout(cycle, delay);
    }

    // if here are more than 2 featured items
    // hiden all but one and cycle through them
    if (nFeature >= 2) {
      $feature.not(':first-child').addClass('invisible');
      cycle();
    }
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function bannerGrid() {
    var $container = $('.banner-grid');
    var $containerSlider = $('.banner-slider');


    // check if the widget element is in the page
    if ($container.length || $containerSlider.length) {
      // API Call
      // Needs pagination. Not enough items received from the API yet.
      var cookie = location.href.indexOf('/empresas') !== -1 ? "1" : "2";
      switch (cookie) {
        case "2":
          call = API_URL_RESIDENTIAL;
          break;

        case "1":
          call = API_URL_COMPANY;
          break;

        default:
          call = API_URL_ALL;
          break;
      }

      $.get(call)
        .done(function (response) {

          var count = response.count;
          var next = response.next;
          var prev = response.previous;
          var partners = response.results;

          if (partners.length) {
            // Iterate every partner
            partners.map(function (partner) {
              var logo = partner.hi_res_logo;
              var name = partner.designation;
              var tipo = partner.offer_types[0].name;
              var href = 'comercializadores/#/' + slugify(tipo) + '/' + slugify(name.toLowerCase());

              //Skip any partner without logo or name
              if (logo && name) {
                // If partner doesnt have a website print empty anchor
                if (!href) {
                  href = '#';
                }
                // build the list item and append it
                var listItem = '<div><a href="' + href + '"><img src="' + DOMAIN + logo + '" alt="' + name + '"/></a></div>';
                $container.append(listItem);
                $containerSlider.append(listItem);
              }
            });
          }
          //bannerlogosAnimation(); //animaite banner-slider
          setTimeout(resizePartnersBanners, 500);
        });
    }
  }

  function accordionMenu() {
    $box = $("div[class$='-box']");
    $header = $("div[class$='-box'] .accordion ");
    if ($box.length) {
      $header.click(function () {
        $(this).toggleClass('open');
        $(this).next().slideToggle();
      });
    }
  }


  function isColliding(el1, el2) {

    el1.Height = el1.offset().top + el1.outerHeight(true);
    el1.Width = el1.offset().left + el1.outerWidth(true);

    el2.Height = el2.offset().top + el2.outerHeight(true);
    el2.Width = el2.offset().left + el2.outerWidth(true);


    return !(
      (el1.Height <= el2.offset().top) ||
      (el1.offset().top >= el2.Height) ||
      (el1.Width <= el2.offset().left) ||
      (el1.offset().left >= el2.Width)
    );
  }


  var shareButtonsCollided = false;
  var shareButtonsHidden = false;
  function shareButtonOnScroll() {
    var $share = $('.adene-share-buttons'),
      $body = $('body'),
      $feature = $('.feature');

    if ($share.length > 0) {
      var scrollTop = $(window).scrollTop(),
        headerOffset = $('.main-header').outerHeight(),
        elementOffset = $share.parents('.row').offset().top - headerOffset,
        distance = (elementOffset - scrollTop);

      if ($feature.length > 0) {
        shareButtonsCollided = isColliding($share, $feature);

        if (shareButtonsCollided) {
          if (!shareButtonsHidden) {
            $share.animate({ opacity: 0 }, 100, function () {
              shareButtonsHidden = true;
            });
          }
        } else {
          if (shareButtonsHidden) {
            $share.animate({ opacity: 1 }, 100, function () {
              shareButtonsHidden = false;
            });
          }
        }
      }

      // Single-dicas Page Template
      if ($body.hasClass('single-dicas')) {
        if (distance < -65 && !$share.hasClass('stick-to-top')) {
          $share.addClass('stick-to-top');
        } else if (distance >= -65 && $share.hasClass('stick-to-top')) {
          $share.removeClass('stick-to-top');
        }
      } else {
        // if its negative, stick share buttons to the top
        if (distance < 100 && !$share.hasClass('stick-to-top')) {
          $share.addClass('stick-to-top');
        } else if (distance >= 100 && $share.hasClass('stick-to-top')) {
          $share.removeClass('stick-to-top');
        }
      }
    }
  }

  // https://gist.github.com/Bloggerschmidt/61beeca2cce94a70c9df
  function imgToSvg() {
    $('img')
      .each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find('svg');

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

        }, 'xml');
      });
  }

  // Applied in the Tabs component in page "Mudar"
  // Move the image outside of the panel body and place it above the title
  function moveImageAboveTitle() {
    var $tabsPanel = $('.tabs-comercializador .vc_tta-panels .vc_tta-panel');
    $tabsPanel.each(function () {
      var $title = $(this).find('.vc_tta-panel-heading').first();
      var $image = $(this).find('.wpb_single_image').first();
      var $click = $(this).find('a').first().clone(true);
      $click.empty();
      $image.find('figure').wrap($click);
      $image.prependTo($title);
    });
  }

  // Scroll to ID with and offset
  // For anchors that href to and ID (href="#spot")
  function offSetAnchorScroll() {
    // The function actually applying the offset
    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
      }
    }
    // Captures click events of all <a> elements with href starting with #
    $('.legistalation-categories, .faq-categories')
      .on('click', 'a[href^="#"]', function (event) {
        // Click events are captured before hashchanges. Timeout causes offsetAnchor to
        // be called after the page jump.
        window
          .setTimeout(function () {
            offsetAnchor();
          }, 0);
      });

    // Set the offset when entering page with hash present in the url
    window.setTimeout(offsetAnchor, 0);
  }

  function clearContactForm7() {
    var formID = $('.wpcf7').attr('id');

    if (formID) {
      $('[name="area"]').change(function () {
        $('form.wpcf7-form').find('[data-class="wpcf7cf_group"]').each(function (i) {
          $group = $(this);

          if ($group.css('display') != 'none' && !$group.hasClass('wpcf7cf-hidden')) {
            if ($group.attr('data-clear_on_hide') !== undefined) {
              var value = $(':input', $group).val();

              $group.find("[data-value='" + value + "']").remove();
              $(':input[type="text"]', $group).attr("placeholder", "Escolha uma opção").css({ "width": "116px", "opacity": 1, "position": 'relative', "left": 0 });
              $(':input[type="text"]', $group).parent().attr('class', "selectize-input items not-full has-options");

              $(':input', $group).find(":selected").val('');
              $(':input', $group).find(":selected").text('');

              $(':input', $group).val('');
            }
          }
        })
      })
    }
  }


  // Check if element is in view
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem)
      .offset()
      .top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom));
  }

  // Animate Numbers. Add .count to an element with numbers
  var counterIsRunning = false;

  function animateNumbers() {
    var $count = $('.count');

    if ($count.length > 0) {
      if (!counterIsRunning) {
        if (isScrolledIntoView($count)) {
          $count.each(function () {
            counterIsRunning = true;

            var value = $(this).text().split(",")[0];
            var decimal = ($(this).text().split(",")[1]) || '00';

            $(this)
              .prop('Counter', 0)
              .animate({
                Counter: value
              }, {
                duration: 1500,
                easing: 'linear',
                step: function (now) {
                  var val = Number(Math.ceil(now * 100) / 100);
                  val = parseFloat(val).toFixed(2);
                  val = val.replace(".", ",");
                  $(this).text(val);
                },
                complete: function (now) {
                  $(this).text(value + ',' + decimal);
                }
              });
          });
        }
      }
    }
  }

  // Apply selectize to select boxes
  function selectizeInputs() {
    var $selects = $('.wpcf7-form select');

    if ($selects.length > 0) {

      $selects.each(function () {

        $(this).selectize({

          create: true,
          sortField: 'text',

        });

      });

    }
  }

  // Logic for the "Limpar pesquisa" button
  function clearSearch() {
    var $clear = $('.no-results a');
    if ($clear.length > 0) {
      $clear.click(function (event) {
        event.preventDefault();
        var $input = $('input[name="search_query"');
        $input.val("");
      });
    }
  }

  function resizePartnersBanners() {
    var $logo = $('.banner-grid img');

    if ($logo.length > 0) {
      $logo.each(function () {
        var width = $(this).width();
        var height = $(this).height();
        if (height > 100) {
          $(this).css('height', '70px');
          $(this).css('width', 'auto');
          $(this).css('padding', '25px');
        } else if (width / height > 4) {
          $(this).css('width', '140px');
          $(this).css('height', 'auto');
        }
      });
    }
  }

  // Add button on focus for accessibility reasons
  function footerSearch() {
    var $search = $('.main-footer .search-field');
    var $form = $('.main-footer .search-form');

    if ($search.length > 0) {
      $('<a class="searchFocus"></a>').appendTo('.main-footer .search-form');
      $('.searchFocus').addClass('hidden');

      $('.searchFocus').click(function (e) {
        e.preventDefault();
        $('.main-footer .search-form').submit();
      });

      $search.keyup(function () {
        if ($search.val().length > 0) {
          $('.searchFocus').removeClass('hidden');
        }
        if ($search.val().length === 0) {
          $('.searchFocus').addClass('hidden');
        }
      });

      $search.blur(function () {
        if ($search.val().length === 0) {
          if ($search.hasClass('hidden')) {
            $('.searchFocus').addClass('hidden');
          }
        }
      });
    }
  }

  // Removes <h3> header from search widget
  function removeSearchTitle() {
    var header = $('.search-5 h3');
    header.remove();
  }

  // Changes form input id to prevent duplicates
  function changeSearchId() {
    $('.search-4 form label').attr('for', 'search-field-2');
    $('.search-4 form label input').attr('id', 'search-field-2');
  }


  function animateMobileMenu() {
    var open = false;
    var $menu = $('.mobile-menu');
    var $rightcontainer = $('.nav-primary .right-container');

    if ($menu.length > 0) {
      $menu.on('click', function () {
        if (!open) {
          $menu.addClass('openMenu');
          $menu.find('.openIcon').fadeOut(100, function () {
            $menu.find('.closeIcon').fadeIn();
            $rightcontainer.fadeOut();

          });
          open = true;
        } else {
          $menu.removeClass('openMenu');
          $menu.find('.closeIcon').fadeOut(100, function () {
            $menu.find('.openIcon').fadeIn();
            $rightcontainer.fadeIn();
          });
          open = false;
        }
      });
    }
  }

  // Click event for hovering menu and help menu
  function hoveringMenuClick() {
    var $menu = $('.menu-flutuante'),
      $menuajuda = $('.menu-ajuda'),
      $mask = $('.mask');      

    if ($menu.length > 0) {

      var $title = $menu.find('a.title').first();
      $title.click(function (e) {
        e.preventDefault();
      });

    }

    if ($menuajuda.length > 0) {

      var $title = $menuajuda.find('a.title').first();

      $title.click(function (e) {

        e.preventDefault();
        $menuajuda.toggleClass('extended');

      });

    }

    jQuery('.mask .title').addClass('newClass');
    jQuery('.mask .title').attr('href', 'https://poupaenergia.pt/simulador-simples');


  }


  // Check if page is correct to render help menu
  // only show in "simulador avançado" and "simulador simples" and "empresarial"
  function whereToRenderHelpMenu() {
    var path = window.location.pathname,
      slugs = ["simulador-avancado", "simulador-simples", "empresarial"],
      found = slugs.some(function (slug) {

        // Dont' show menu on company pages
        //if ($('body').hasClass('is-company'))
        //return 1;

        return path.indexOf(slug) >= 0;

      });

    if (found) {

      renderHelpMenu();

    }

  }

  // Render hovering menu
  function renderHelpMenu() {
    var $menu = $('.menu-ajuda');
    var $mask = $('.mask');

    if ($menu.length > 0) {

      var $mask = $('.mask'),
        scrollPosition = $(window).scrollTop(),
        headerHeight = 0,
        menuOffset = $menu.offset(),
        quarterHeight = $(window).height(),
        quarterHeight = quarterHeight / 4 + 70,
        adeneHeaderExists = !!$('.adene-header-presentation').length,
        headerExists = !!$('.header').length;

      if (headerExists) {

        headerHeight = $('.header').height();

      } else if (adeneHeaderExists) {

        headerHeight = $('.adene-header-presentation').height();

      } else {

        headerHeight = 100;

      }

      if (headerHeight < scrollPosition) {

        $menu.addClass('retracted');

      } else {

        $menu.removeClass('retracted');

      }

    } else {

      $mask.css('display', 'none');

    }

  }



  // Render hovering menu
  function renderMenu() {
    var $menu = $('.menu-flutuante');
    var $mask = $('.mask');

    if ($menu.length > 0) {

      var $mask = $('.mask'),
        scrollPosition = $(window).scrollTop(),
        headerHeight = 0,
        menuOffset = $menu.offset(),
        quarterHeight = $(window).height(),
        quarterHeight = quarterHeight / 4 + 70,
        adeneHeaderExists = !!$('.adene-header-presentation').length,
        headerExists = !!$('.header').length;

      if (headerExists) {

        headerHeight = $('.header').height();

      } else if (adeneHeaderExists) {

        headerHeight = $('.adene-header-presentation').height();

      } else {

        headerHeight = 100;

      }

      if (headerHeight < scrollPosition) {

        $menu.addClass('retracted');

      } else {

        $menu.removeClass('retracted');

      }

    } else {

      $mask.css('display', 'none');

    }

  }


  // Check if page is correct to render hovering menu
  // Dont run this in pages "simulador avançado" and "simulador simples"
  function whereToRenderHoveringMenu() {
    var path = window.location.pathname,
      slugs = ["simulador-avancado", "simulador-simples"],
      found = slugs.some(function (slug) {

        // Dont' show menu on company pages
        if ($('body').hasClass('is-company'))
          return 1;

        return path.indexOf(slug) >= 0;

      });

    if (!found) {

      renderMenu();

    }

  }




  function animatedText() {
    var $text = $('.cycle-text');

    if ($text.length > 0) {

      var text = $text.text();
      string = text.split("|");

      $text.text("");

      var typed = new Typed('.cycle-text', {
        strings: string,
        typeSpeed: 50,
        loop: true,
        backSpeed: 20,
        backDelay: 800
      });

    }

  }

  function tipsTagsClick() {
    var $tag = $('.tip-tag');

    if ($tag.length > 0) {

      $tag.click(function (e) {

        var url = $(this).attr('data-url');
        window.location = url;
        e.preventDefault();

      });

    }
  }

  function eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  function openAccordionItem() {
    var url = document.location.href,
      searchPattern = "\\#(.*)[0-9]{1,4}",
      rx = new RegExp(searchPattern, "gim"),
      result = rx.exec(url),
      $faqPage = $('body.duvidas'),
      $legPage = $('body.legislacao');


    if ($faqPage.length > 0 || $legPage.length > 0) {
      if (result !== null) {
        var id = result[0].substring(1),
          item = document.getElementById(id);
        eventFire(item, 'click');
        setTimeout(function () {
          window.location.hash = '#' + id;
        }, 300);
      }
    }
  }

  function loadingForReactApps() {
    var apps = [
      'adene-simulador-avancado',
      'adene-simulador-simples',
      'adene-simulador-empresarial',
      'adene-preregister',
      'adene-tariffs',
      'adene-login'
    ];

    var foundElement = false
    $.each(apps, function (index, element) {
      $el = $('#' + element);
      if ($el.length > 0) {
        foundElement = $el
      }
    });

    if (foundElement) {
      var count = foundElement.children().length
      if (count > 0) {
        foundElement.addClass('loaded')
        clearInterval(checkLoadingReactApps)
      }
    }
  }

  function truncateUserName(name) {
    if (!name) return ''
    var nameSplit = name.split(' ')
    var trunc = $.grep(nameSplit, function (ele, idx) {
      return idx === 0 || idx === nameSplit.length - 1
    })

    return trunc.join(' ')
  }

  function isLoggedIn() {
    var me = window.API + 'private/user-profile/me/'
    var token = localStorage.getItem('tokenauth')
    if (token) {
      $.ajax({
        method: 'get',
        url: me,
        headers: {
          Authorization: 'JWT ' + token
        }
      }).then(function (data) {
        var user = data;
        $('#profile-link').attr('href', '/area-reservada');
        $('#name').html(truncateUserName(user.user.name));
        $('#subname').html('Area reservada');

      })
    }

  }

  // Add logic to button rating
  function addClickToRatingButton() {
    if (window.location.pathname.includes('avaliar-tarifario')) {
      // Get URL params
      var urlParams = new URLSearchParams(window.location.search);
      var subscription = urlParams.get('subscription');
      var token = urlParams.get('token');

      // If url doesnt have subscription code or token, redirect to 404
      if (!subscription || !token) {
        location.href = '/404';
      }

      var ratingButton = document.getElementById('submit_rating');
      ratingButton.addEventListener('click', submitRating);
    }
  }

  // Get rating value from stars
  function getRatingValue(name) {
    for (i = 0; i < document.getElementsByName(name).length; i++) {
      if (document.getElementsByName(name)[i].checked == true) {
        var ratingValue = document.getElementsByName(name)[i].value;
        break;
      }
    }
    return ratingValue
  }

  // Validate Rating Form
  function validateRatingForm(form) {
    var obj = { error: false, message: '' };
    var keys = Object.keys(form);

    for (var i = 0; i < keys.length; i++) {
      if (!form[keys[i]]) {
        if (keys[i] === 'rating_1' || keys[i] === 'rating_2' || keys[i] === 'rating_3') {
          obj = { error: true, message: 'Avalie por favor todas as questões.' };
        }
      }
    }

    return obj;
  }

  function submitRating() {
    var firstRating = getRatingValue('rating_1');
    var secondRating = getRatingValue('rating_2');
    var thirdRating = getRatingValue('rating_3');
    var description = document.getElementsByClassName('rating_textarea')[0].value;
    var checkbox = document.getElementById('permit_checkbox').checked;

    // Get URL params
    var urlParams = new URLSearchParams(window.location.search);
    var subscription = urlParams.get('subscription')
    var token = urlParams.get('token');

    var dataObj = {
      subscription: subscription,
      feedback_token: token,
      rating_1: firstRating,
      rating_2: secondRating,
      rating_3: thirdRating,
      observations: description,
      authorize: checkbox
    };

    // Validate form
    const valid = validateRatingForm(dataObj)

    if (valid.error) {
      document.getElementById('error').innerHTML = valid.message;
    }

    // API POST
    var feedback = window.API + 'public/subscribe-price-list/feedback/';
    if (!valid.error) {
      $.ajax({
        method: 'post',
        url: feedback,
        data: dataObj,
      }).then(function (data) {
        // Hide error if it was true
        document.getElementById('rating_error').style.display = 'none';

        // Show modal if pass trough
        document.getElementById('rating_modal').style.display = 'block';
        document.getElementById('modal_overlay').style.display = 'block';
      }).fail(function (error) {
        console.log('❌ -> Something went wrong!', error)
        document.getElementById('error').innerHTML = 'Tente novamente.';
        document.getElementById('rating_error').style.display = 'block';
      })
    } else {
      // Show Error Message
      document.getElementById('rating_error').style.display = 'block';
    }
  }

  function validateContactFormSubGroups() {
    var $page = $('body.contactos'),
      $groupA = $('#a'),
      $groupB = $('#b'),
      $groupC = $('#c'),
      $submit = $('.wpcf7-submit'),
      error = '<span role="alert" style="margin-bottom: 20px; margin-top: -10px;"  class="wpcf7-not-valid-tip">O CAMPO É OBRIGATÓRIO.</span>';


    function clearError() {
      var $error = $('wpcf-3-not-valid-tip');
      $error.remove();
    }

    if ($page.length > 0) {

      $submit.on('click', function (e) {

        if ($groupA.is(':visible') && !$groupA.find('.selectize-dropdown-content .option.selected.active').length) {
          e.preventDefault();

          if (!$groupA.find('.wpcf7-not-valid-tip').length) {
            clearError();
            $groupA.append(error);
          }

          return;
        }

        if ($groupB.is(':visible') && !$groupB.find('.selectize-dropdown-content .option.selected.active').length) {
          e.preventDefault();

          if (!$groupB.find('.wpcf7-not-valid-tip').length) {
            clearError();
            $groupB.append(error);
          }

          return;
        }

        if ($groupC.is(':visible') && !$groupC.find('.selectize-dropdown-content .option.selected.active').length) {
          e.preventDefault();

          if (!$groupC.find('.wpcf7-not-valid-tip').length) {
            clearError();
            $groupC.append(error);
          }

          return;
        }

      });
    }
  }

  function slickStatsWidget() {
    setTimeout(function () {
      var $stats = $('.stats'),
        isSlicked = false;

      if ($stats.length) {

        if ($(window).width() <= 790) {

          $stats.not('.slick-initialized').slick({
            speed: 1000,
            autoplay: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,
            buttons: true
          });

          isSlicked = true

        } else {

          if ($('.stats').hasClass('slick-initialized')) {
            $('.stats').slick('unslick');
          }
        }
      }
    }, 500)

  }

  function formatNumbers(locale, number) {
    return number.toLocaleString(locale, number);
  }

  function statsWidgetNumberFormatting() {

    var $stats = $('.stats'),
      $number = $('.stats .number');

    if ($stats.length) {

      $number.each(function () {

        var value = $(this).text();
        value = parseInt(value, 10);

        $(this).text(formatNumbers('pt-PT', value));

      });

    }
  }

  function shuffleArray(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
  }

  function stats() {
    setTimeout(function () {
      if (typeof API !== "undefined") {
        var API_URL = API + 'public/statistic/general/';

        if ($('.stats').length) {
          var DECODED_STATS = JSON.parse(STATS);
          $('#stats-zone').html('');
          shuffleArray(DECODED_STATS);
          DECODED_STATS = DECODED_STATS.slice(0, 3);
          var html = '';

          jQuery.get(API + 'public/statistic/general/').then(function (data) {
            DECODED_STATS.forEach(function (stat) {

              if (data[stat.number]) {
                html += '      <div class="adene-number-card pop">';
                html += '          <div class="image-box" >';
                html += '             <img src="' + stat.image[0] + '" alt="' + stat.title + '" />';
                html += '          </div>';
                html += '          <h3 class="number">' + formatNumbers('pt-PT', data[stat.number]) +  (stat.number === "saved_money_count" ? " €/ano" : "") + '</h3>';
                html += '          <h4 class="title">' + stat.title + '</h4>';
                html += '          <p class="text">' + stat.description + '</p>';
                html += '      </div>';
              }
            })

            $('#stats-zone').html(html);
            setTimeout(function () {
              if ($(window).width() <= 790) {
                slickStatsWidget();
              }
            }, 100);


          })
        }
      }
    }, 100);
  }

  function novidades() {
    var DECODED_NOVIDADES = JSON.parse(POSTS_NOVIDADES);
    var AUTOPLAY_SPEED = JSON.parse(POSTS_NOVIDADES_AUTOPLAY);
    var AUTOPLAY_SPEED_INT = parseInt(AUTOPLAY_SPEED);
    var sliderClicked = false;

    var html = '';
    var i = 1;

    function slice(text) {
      return text.length >= 120 ? text.slice(0, 120) + '...' : text;
    }

    DECODED_NOVIDADES.forEach(function (novidade) {
      if (novidade.post_title && novidade.post_description) {
        html += '<label for="s' + i + '" id="slide' + i + '">';
        html += '<div class="post-box">';
        html += '<div class="post-image">';
        html += '<img src="' + novidade.image[0] + '" alt="poupa-energia-image" />';
        html += '</div>';
        html += '<div class="post-text">';
        html += '<span class="post-text-title">' + novidade.post_title + '</span>';
        html += '<div class="post-text-description">';
        html += slice(novidade.post_description);
        html += '</div>';
        html += '<a class="post-text-button" href="' + novidade.post_link + '">Ler Mais</a>';
        html += '</div>';
        html += '</div>';
        html += '</label>';
      } else if (novidade.youtube_link) {
        html += '<label for="s' + i + '" id="slide' + i + '">';
        html += '<iframe align="middle" src="' + novidade.youtube_link + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="youtube-iframe"></iframe>';
        html += '</label>';
      } else if ((novidade.image && novidade.image_link) || novidade.image) {
        html += '<label for="s' + i + '" id="slide' + i + '">';
        html += '<a href="' + novidade.image_link + '" target="_blank">'
        html += '<img src="' + novidade.image[0] + '" class="novidade-image"/>';
        html += '</a>'
        html += '</label>';
      }

      i++;
    })

    i = i - 1;

    var radioHtml = '<div class="radio-slider-wrapper">';
    for (var k = 1; k <= i; k++) {
      if (k === 2) {
        radioHtml += '<input type="radio" name="slider" id="s' + k + '" checked>';
      } else {
        radioHtml += '<input type="radio" name="slider" id="s' + k + '">';
      }
    }
    radioHtml += '</div>'

    var content = '<section id="slider">' + radioHtml + html + '</section>';
    $('#novidades-box').html(content);

    var currentSlideID = '#slide2';
    var previousSlideID = '#slide1';
    var nextSlideID = '#slide3';

    $(currentSlideID).css({ "transform": "translate3d(0,0,0)" });
    $(previousSlideID).css({ "transform": "translate3d(-165%,0,-100px)" });
    $(nextSlideID).css({ "transform": "translate3d(165%,0,-100px)" });

    for (var z = 4; z <= k; z++) {
      var slideID = '#slide' + z;
      $(slideID).css({ "transform": "translate3d(320%,0,-100px)" });
    }

    setInterval(function () {
      if (!sliderClicked) {
        var currentSlideID = $('input[name=slider]:checked').attr('id').slice(1);

        if (parseInt(currentSlideID) === i) {
          var nextSlideID = "s1";
        } else {
          var nextSlideID = "s" + (parseInt(currentSlideID) + 1);
        }

        $("#s" + currentSlideID + "").removeAttr("checked");
        $("#" + nextSlideID + "").attr("checked", true);

        if (parseInt(currentSlideID) === i) {
          var id = 1;
        } else {
          var id = parseInt(currentSlideID) + 1;
        }
        for (var y = 1; y <= i; y++) {
          var offSlideID = '#slide' + y;
          if (y <= (id - 2)) {
            $(offSlideID).css({ "transform": "translate3d(-320%,0,-100px)" });
          } else if (y >= (id + 2)) {
            $(offSlideID).css({ "transform": "translate3d(320%,0,-100px)" });
          } else if (y === (id + 1)) {
            $(offSlideID).css({ "transform": "translate3d(165%,0,-100px)" });
          } else if (y === (id - 1)) {
            $(offSlideID).css({ "transform": "translate3d(-165%,0,-100px)" });
          } else if (y === id) {
            $(offSlideID).css({ "transform": "translate3d(0,0,0)" });
          }
        }
      }
    }, AUTOPLAY_SPEED_INT);

    $('input[type=radio]').on("click", function (e) {
      sliderClicked = true;
      var id = parseInt(e.target.id.slice(1));

      for (var y = 1; y <= i; y++) {
        var offSlideID = '#slide' + y;
        if (y <= (id - 2)) {
          $(offSlideID).css({ "transform": "translate3d(-320%,0,-100px)" });
        } else if (y >= (id + 2)) {
          $(offSlideID).css({ "transform": "translate3d(320%,0,-100px)" });
        } else if (y === (id + 1)) {
          $(offSlideID).css({ "transform": "translate3d(165%,0,-100px)" });
        } else if (y === (id - 1)) {
          $(offSlideID).css({ "transform": "translate3d(-165%,0,-100px)" });
        } else if (y === id) {
          $(offSlideID).css({ "transform": "translate3d(0,0,0)" });
        }
      }
    })
  }

  function setSmartAppBanner() {
    var cookieSmartBanner = Cookies.get("SmartBannerClose")
    var mobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      }
    }

    if ((mobile.Android() || mobile.iOS()) && !cookieSmartBanner) {
      // Position correctly nav primary
      $(".nav-primary").addClass("MT1400 MT767 .MT159")

      var html = "<div class='smartbanner'>"
      html += "<div class='smartbanner-content'>"
      html += "<div class='smartbanner-message-container'>"
      html += "<img src='/app/themes/custom/assets/images/ic-banner-close.svg' alt='close' class='smartbanner-close-icon' />"
      html += "<img src='/app/themes/custom/assets/images/app-icon.svg' alt='Poupa Energia' class='smartbanner-app-icon' />"
      html += "<div class='smartbanner-message'>"
      html += "<span class='smartbanner-title'>Poupa Energia</span>"
      html += "<span class='smartbanner-description'>Mais rápida e acessível!</span>"
      html += "</div>"
      html += "</div>"
      html += "<div class='smartbanner-button'>"
      if (mobile.Android()) html += "<a href='https://play.google.com/store/apps/details?id=com.apppenergia' target='_blank'><img src='/app/themes/custom/assets/images/btn-play-store.svg' alt='Play Store' class='smartbanner-store-icon' /></a>"
      else if (mobile.iOS()) html += "<a href='https://apps.apple.com/us/app/poupa-energia/id1454648846?l=pt&ls=1' target='_blank'><img src='/app/themes/custom/assets/images/btn-app-store.svg' alt='App Store' class='smartbanner-store-icon' /></a>"
      html += "</div>"
      html += "</div>"
      html += "</div>"

      $(".main-header").prepend(html)
    }
  }

  function SmartAppBannerControls() {
    $close = $(".smartbanner-close-icon")

    if ($close) {
      $close.bind("click", function () {
        $(".smartbanner").css('display', 'none')
        $(".nav-primary").removeClass("MT1400 MT767 .MT159")
        Cookies.set("SmartBannerClose", true, { expires: 4 })
      })
    }
  }

  function MobilidadeEletricaMap() {
    var hide_tipo_posto = JSON.parse(DISPLAY_TIPO_POSTO);
    var html = ''

    html += "<div class='map-wrapper'>"
    html += "<div class='map-filter-container'>"

    if (!hide_tipo_posto) {
      html += "<div style='margin-bottom: 28px;'>"
        html += "<div class='filter-title'>"
          html += "<img src='https://teste.poupaenergia.pt/app/uploads/2019/08/tomada-carro.svg' class='filter-title-image' alt='Car' />"
          html += "<span>Tipo de Posto</span>"
        html += "</div>"
        html += "<div class='checkbox-label'>"
          html += "<div class='checkbox-fauxCheck'>"
            html += "<div class='checkbox-checkmark' id='map-checkbox-mobie' style='display:block'></div>"
          html += "</div>"
          html += "<input type='checkbox' class='checkbox-innerCheck' id='map-checkbox-mobie' name='mobie' checked/>"
          html += "Mobi.e"
        html += "</div>"
      html += "</div>"
    }

    html += "<div style='margin-bottom: 28px;'>"
      html += "<div class='filter-title'>"
        html += "<img src='https://teste.poupaenergia.pt/app/uploads/2019/08/tomada-carro.svg' class='filter-title-image' alt='Car' />"
        html += "<span>Tipo de Carregamento</span>"
      html += "</div>"

      html += "<div class='checkbox-label'>"
        html += "<div class='checkbox-fauxCheck'>"
          html += "<div class='checkbox-checkmark' id='map-checkbox-normal' style='display:block'></div>"
        html += "</div>"
        html += "<input type='checkbox' class='checkbox-innerCheck' id='map-checkbox-normal' name='normal' checked style='opacity: 0;position: absolute;width:16px;height: 16px;' />"
        html += "Normal"
      html += "</div>"

      html += "<div class='checkbox-label'>"
        html += "<div class='checkbox-fauxCheck'>"
          html += "<div class='checkbox-checkmark' id='map-checkbox-rapido' style='display:block'></div>"
        html += "</div>"
        html += "<input type='checkbox' class='checkbox-innerCheck' id='map-checkbox-rapido' name='fast' checked style='opacity: 0;position: absolute;width:16px;height: 16px;' />"
        html += "Rápido"
      html += "</div>"
    html += "</div>"

    html += "</div>"
    html += "</div>"

    $('#mobilidade-eletrica-map-box').html(html);

    html = ''
    html += "<div class='map-container'>"
      html += "<div id='map'></div>"
    html += "</div>"

    console.log(html)

    $('#mobilidade-eletrica-map-box .map-wrapper').append(html);
    initMap();
  }

  function fetchChargingStations(url) {
    url = url ? url : API + 'public/charging-stations/';

    fetch(url).then(function (response) {
      return response.json()
    }).then(function (response) {
      const nextPageURL = response.next
      const stations = response.results
      chargingStationsMarkers = chargingStationsMarkers.concat(stations)

      if (nextPageURL) {
        fetchChargingStations(nextPageURL)
        return
      }

      loadingChargingStations = false
      addMarkersToChargingMap()
    })
  }


  var markerClusterCharging
  function addMarkersToChargingMap() {
    var markerIcon = L.icon({ // Create Icon for markersicon
      iconUrl: 'https://teste.poupaenergia.pt/app/uploads/2019/08/marker.svg',
      iconSize: [31, 40],
      iconAnchor: [15, 0]
    });

    markerClusterCharging = L.markerClusterGroup({
      iconCreateFunction: function (cluster) {
        return L.divIcon({ html: cluster.getChildCount(), className: 'map-cluster', iconSize: L.point(40, 40) });
      },
      spiderfyOnMaxZoom: false, showCoverageOnHover: false, zoomToBoundsOnClick: false
    });

    controlSearch = new L.Control.Search({
      position: 'topleft',
      layer: markerClusterCharging,
      initial: false,
      zoom: 17,
      marker: false,
      textErr: "Localização não encontrada.",
      textCancel: "Cancelar",
      textPlaceholder: "Pesquisar posto...",
    });

    chargingStationsMap.addControl(controlSearch);

    chargingStationsMarkers.forEach(function (station) {
      var marker = new L.Marker(
        new L.latLng(station.latitude, station.longitude),
        { icon: markerIcon }
      );

      marker.bindPopup(station.station_id + " - " + station.charging_type)
      markerClusterCharging.addLayer(marker);
    })

    chargingStationsMap.addLayer(markerClusterCharging);
  }

  function initMap() {

    // http://leafletjs.com/reference-1.1.0.html#class-constructor-hooks
    L.Map.addInitHook(function () {
      mapsPlaceholder = this; // Use whatever global scope variable you like.
    });

    chargingStationsMap = new L.Map('map', { zoom: 6, zoomControl: false, center: [39.601305, -9.068622] });	// Set center from first location
    L.control.zoom({ position: 'bottomright' }).addTo(chargingStationsMap); // Set control zoom to bottom right

    var currentLocationControl = L.Control.extend({ // Set current location control bo bottom right
      options: {
        position: 'bottomright'
      },
      onAdd: function (map) {
        var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-current-location');

        container.style.backgroundColor = 'white';
        container.style.backgroundImage = "url(https://teste.poupaenergia.pt/app/uploads/2019/08/crosshairs-gps.png)";
        container.style.backgroundSize = "20px 20px";
        container.style.backgroundRepeat = "no-repeat"
        container.style.backgroundPosition = "center"
        container.style.width = '34px';
        container.style.height = '34px';
        container.style.cursor = 'pointer';

        container.onclick = function () {
          // Get current location and adds marker to map
          map.locate({ setView: true, watch: true }) /* This will return map so you can do chaining */
            .on('locationfound', function (e) {
              var latlng = new L.LatLng(e.latitude, e.longitude);
              map.setView(latlng, 15);
            })
            .on('locationerror', function (e) {
              console.log(e);
              alert("Location access denied.");
            });
        }
        return container;
      },
    });

    chargingStationsMap.addControl(new currentLocationControl());
    chargingStationsMap.addLayer(new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'));
    chargingStationsMap.invalidateSize();
    window.chargingStationsMap = chargingStationsMap;

    fetchChargingStations()
  }

  function mapControls() {
    $('#map-checkbox-privado, #map-checkbox-mobie').change(function (bt) {
      toggleCheckbox(bt.currentTarget.checked, bt.currentTarget.id)
      filterMarkers(bt.currentTarget.checked, 'station_type', bt.currentTarget.name)
    })

    $('#map-checkbox-normal, #map-checkbox-rapido').change(function (bt) {
      toggleCheckbox(bt.currentTarget.checked, bt.currentTarget.id)
      filterMarkers(bt.currentTarget.checked, 'charging_type', bt.currentTarget.name)
    })
  }

  function toggleCheckbox(checked, id) {
    if (checked) $('div#' + id).css('display', 'block');
    else $('div#' + id).css('display', 'none');
  }

  function filterMarkers(filterChecked, type, filterName) {
    if (filterChecked) { // Just filter if the button is checked
      filterMapNames.push({ type: type, value: filterName })
    } else {
      filterMapNames = filterMapNames.filter(function (val) {
        return val.type !== type && val.value !== filterName
      })
    }

    console.log(filterMapNames)

    // Clear all layers except the osm layer (the first layer)
    var i = 0
    chargingStationsMap.eachLayer(function (layer) {
      if (i > 0) chargingStationsMap.removeLayer(layer)
      if (i === 0) i++
    });

    var markerIcon = L.icon({ // Create Icon for markersicon
      iconUrl: 'https://teste.poupaenergia.pt/app/uploads/2019/08/marker.svg',
      iconSize: [31, 40],
      iconAnchor: [15, 0]
    });

    markerClusterCharging.clearLayers();
    markerClusterCharging = L.markerClusterGroup({
      iconCreateFunction: function (cluster) {
        return L.divIcon({ html: cluster.getChildCount(), className: 'map-cluster', iconSize: L.point(40, 40) });
      },
      spiderfyOnMaxZoom: false, showCoverageOnHover: false, zoomToBoundsOnClick: false
    });


    var filteredMapMarkers = chargingStationsMarkers.filter(function (station) {
      return filterMapNames.every(function (n) {
        return station[n.type] === n.value
      })
    })

    filteredMapMarkers.forEach(function (station) {
      var marker = new L.Marker(
        new L.latLng(station.latitude, station.longitude),
        { icon: markerIcon }
      );

      marker.bindPopup(station.station_id + " - " + station.charging_type)
      markerClusterCharging.addLayer(marker);
    })

    console.log(filteredMapMarkers)
    chargingStationsMap.addLayer(markerClusterCharging);
    chargingStationsMap.invalidateSize();
  }


  function setTranslationCookies() {
    if (!Cookies.get('googtrans')) {
      Cookies.set('googtrans', '/pt/en')
    }
  }


  function setLinkRelatorios() {
    $('.relatorio-trimestral').on("click", function (e) {
      e.preventDefault();
      var url = $(this).attr('id');
      window.open(url)
    });
  }

  function fetchAllFaqs(){
    $('.fetch-faqs').on('click',function(){
      var value = $('#myInput').val();
      $('.card-sub').filter(function(){
          var thisText = $(this).text();
          $(this).toggle(thisText.toLowerCase().indexOf(value.toLowerCase()) > -1);
          $('.all-posts h3, .faq-sub').addClass('active');
      });
    });

    $('#definicoes,p[data-cat="definicoes"]').addClass('active');
    $('#definicoes').next('.faq-sub').addClass('active');

    $('#myInput').on('keyup', function(){
      var value2 = $('#myInput').val();
      if(value2 === '') {
        $('.card-sub').filter(function(){
          var thisText2 = $(this).text();
          $(this).toggle(thisText2.toLowerCase().indexOf(value2) > -1);
          $('.all-categories h3, .all-posts h3, .faq-sub').removeClass('active');
          $('#definicoes,p[data-cat="definicoes"]').addClass('active');
          $('#definicoes').next('.faq-sub').addClass('active');
        });
      } else {
        console.log('nao vazio');
      }
    })
  }

  function selectFaqsCategory() {

    $('.select-faqs').on('change', function(){
      var value3 = $(this).val();
      var allPosts = $('.all-posts h3');


        $(allPosts).each(function(i,v){
          var thisData = $(this).data('val');
          if(thisData == value3) {
            $(this).addClass('active'),
            $(this).next('.faq-sub').addClass('active');
          } else {
            $(this).removeClass('active'),
            $(this).next('.faq-sub').removeClass('active')
          }
        })

    });

    $('.all-categories ul li a').click(function(){
      $('.all-posts h3, .faq-body').addClass('active');
      $('.select-faqs').val("todas").change();
    });


    $('.all-categories p').click(function(){
      $('.all-categories p').removeClass('active');
      $(this).addClass('active');
      var value4 = $(this).data('cat');
        
      $('.all-posts h3, .faq-sub').removeClass('active');
      $('#'+value4).addClass('active');
      $('#'+value4).next('.faq-sub').addClass('active');
      
    });

    $('.all-posts .titulo').click(function(){
      $(this).next('.faq-body').toggleClass('active');
      $(this).toggleClass('active');
    });

  }

  function elecLinkBlocks() {
    var lo = $('.elec.orange .adene-see-more').attr('href');
    var lb = $('.elec.blue .adene-see-more').attr('href');
    $('.elec.orange').wrap('<a class="elec-link" href="'+lo+'"></a>');
    $('.elec.blue').wrap('<a class="elec-link" href="'+lb+'"></a>');
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('resize', setSlickMobile);
        setTranslationCookies();
        setSlickMobile();
        setLinkRelatorios();
        setScrolledHeader();
        navUnderline(); //Menu navigation underline
        headerSlider(); //Header image slider
        wrapBoxWithAnchor(); //Wrap ".box" with anchor
        showMenuOnMobile(); // mobile menu
        showNavSearchInput(); //show search menu
        gradientRowHover(); // hover effect for gradient-row
        cycleFeaturedArticles(); // cycle through featured articles
        bannerGrid(); // Load banner grid through API
        accordionMenu(); // Accordion Menu (FAQ's and Legislaçao)
        imgToSvg(); // replace all img with svg
        moveImageAboveTitle(); // Page Mudar, Tabs section
        offSetAnchorScroll(); // margin when href scrolls to and ID
        //IECustomStyles(); // Custom IE stuff
        selectizeInputs(); // Selectize form inputs
        clearSearch(); // Clear search inputs
        footerSearch(); // Adds button on focus
        removeSearchTitle(); // Removes <h3> header from search widget
        changeSearchId(); // Changes form input id to prevent duplicates
        whereToRenderHoveringMenu(); // Can I render hovering menu?
        whereToRenderHelpMenu(); // Can I render help menu?
        hoveringMenuClick(); // Hovering menu click function
        animatedText(); // Cycle animation for text
        tipsTagsClick(); // Handle tags event
        openAccordionItem(); // opens Accordions for Faq and Legislation after clicking a search item
        validateContactFormSubGroups(); // Form validation

        clearContactForm7();
        stats();
        addClickToRatingButton();
        setSmartAppBanner();
        SmartAppBannerControls();

        fetchAllFaqs(); // Page "Energia-Verde filter all faqs by the text written on input"
        selectFaqsCategory(); // Render all faqs of the category selected
        elecLinkBlocks(); // Wrap the content block inside a link referenced by this block

        // No need for this when the page is just the app
        if (!$('body').hasClass('only')) {
          isLoggedIn(); // Auth
          checkLoadingReactApps = setInterval(loadingForReactApps, 100); // React App Loading
        }

        if ($('#novidades-box').length) {
          novidades();
        }

        if ($('#mobilidade-eletrica-map-box').length) {
          MobilidadeEletricaMap();
          mapControls();
        }

        $('.switch-content-form').on('submit', function () {
          window.ga && window.ga('send', 'event', 'portal', 'Mudar para pagina de empresas', 'Mudar para pagina de empresas')
        })
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      if (!$('body').hasClass('common')) {
        UTIL.fire('common');
      }

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  $(document).scroll(function () {
    shareButtonOnScroll();
    animateNumbers(); // Animates any numbers with a class
    whereToRenderHoveringMenu(); // Can I render hovering menu?
    whereToRenderHelpMenu(); // Can I render help menu?
  });

  //Window resize events
  window.onresize = function () {
    slickStatsWidget(); // apply slick to statistics widget
    navUnderline(); //needed to recalcule line width on window resize
  };

})(jQuery, Cookies); // Fully reference jQuery after this point.
